<script setup lang="ts">
interface Props {
  text: string;
  required?: boolean;
  hasError?: boolean;
}

const { text, required = false, hasError = false } = defineProps<Props>();
</script>

<template>
  <label
    class="block mb-1.5 text-label-medium font-semibold"
    :class="hasError ? 'text-error' : 'text-text-secondary'"
  >
    <span>{{ text }}</span>
    <span v-if="required" class="text-text-tertiary"> *</span>
  </label>
</template>
